import {
  mapProjectSettingsModelToDto,
  ProjectSettingsDto,
  ProjectSettingsModel,
} from 'api/dto/ProjectSettings.dto';
import dayjs, { Dayjs } from 'dayjs';

export type SurveySettingsDatesDto = {
  liveStart?: string | null;
  liveStop?: string | null;
};

export type SurveySettingsDto = SurveySettingsDatesDto & {
  name?: string;
  settings: ProjectSettingsDto;
  reportRecipients: string[];
};

export type SurveySettingsModel = {
  name?: string;
  liveStart?: Dayjs | null;
  liveStop?: Dayjs | null;
  settings?: ProjectSettingsModel;
  reportRecipients?: string[];
};

const mapSurveyDateToDto = (date: Dayjs | null | undefined): string | null | undefined => {
  if (date === null) {
    return null;
  }
  if (date === undefined) {
    return undefined;
  }
  return dayjs(date).toDate().toDateString();
};

export function mapSurveySettingsModelToDatesDto(
  model: SurveySettingsModel,
): SurveySettingsDatesDto {
  return {
    liveStop: mapSurveyDateToDto(model.liveStop),
    liveStart: mapSurveyDateToDto(model.liveStart),
  };
}

export function mapSurveySettingsModelToDto(model: SurveySettingsModel): SurveySettingsDto {
  const dto: SurveySettingsDto = {
    ...mapSurveySettingsModelToDatesDto(model),
    settings: model.settings && mapProjectSettingsModelToDto(model.settings),
    reportRecipients: model.reportRecipients && model.reportRecipients,
  };
  if (model.name) {
    dto.name = model.name;
  }
  return dto;
}
